module.exports = __webpack_public_path__ + "static/img/BRIJ (3).a943ff5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pos/BRIJ (3).svg
// module id = 1207
// module chunks = 32